import * as Fingerprint2 from "fingerprintjs2"
import { DeviceData } from "./endpoints/devices";
import { APIError } from './requests/request';
export { generateRealmModels } from "./models";
export { API as DevicesAPI } from "./endpoints/devices"
export { API as UsersAPI } from './endpoints/user'
export { API as LoginAPI } from './endpoints/login'
export { API as PaymentsAPI } from './endpoints/payments'
export { API as ClientsAPI } from './endpoints/client'
export { API as DatasourcesAPI } from './endpoints/datasources'
export { APIError, Session } from './requests/request'
export { DeviceTokenProvider, DeviceData } from './endpoints/devices'
export * from './requests/jsonparser'
export * from './errors'
export * from './models'

export function getDefaultDevice(debug: boolean, language: string): Promise<DeviceData> {
    return new Promise((resolve, reject) => {
        Fingerprint2.getV18((result) => {
            let t: DeviceData = {
                app_version: '1.0',
                build_version: '1',
                device_uuid: result,
                device_data_os: 'web',
                debug: debug,
                language: language
            }
            resolve(t)
        })
    })
}

export function errorToString(err: APIError, defaultMessage = 'An unhandled error occurred. Please try again later.'): Array<string> {
    if (err && err.type == 'InvalidParametersError') {
        return Object.keys((err as any).invalid_keys).map((key) => {
            return key + ': ' + (err as any).invalid_keys[key]
        })
    } else if (err && err.type == 'ResourceAlreadyExists' || err && err.message) {
        return [err.message]
    } else {
        return [defaultMessage]
    }
}


// WEBPACK FOOTER //
// ./src/api/index.ts